<template>
  <div class="dft-container" :style="[container_Style]">
    <div class="dft-richtext_box" :style="[richtext_box_Style]">
      <div class="rqe-box" v-html="richTextData"></div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    compData: {
      type: [Array, Object],
      default: () => []
    }
  },
  options: {
    styleIsolation: 'shared' // 解除样式隔离
  },
  data () {
    return {
      showDialog: false
    }
  },
  watch: {
    compData: {
      handler: function (newVal) {
        if (newVal) {
          this.$nextTick(() => {
            // console.log('comp--D-ata',newVal)
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    // 数据
    richTextData () {
      return this.compData?.attr?.a3?.value
    },
    // 样式
    container_Style () {
      return {
        'background': this.compData?.attr?.['a1']?.value,
        'padding': `${this.compData?.attr?.['a2']?.value}px`
      }
    },
    richtext_box_Style () {
      return {
      }
    }
  },
  created () {
  },

  mounted () {
    this.$nextTick(() => {
    })
  },

  methods: {
    initData () {
    }
  }
}
</script>

<style lang="scss" scoped>
.dft-container{
  width: 100%;
  height: auto;
  box-sizing: border-box;
}
.dft-richtext_box{
  display: flex;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  align-items: center;
  font-size: 14px;
}
.rqe-box{
  width: 100%;
}
</style>
